<script>
import GeneralTable from '@/components/GeneralComponents/GeneralTable.vue'
import GeneralModal from '@/components/GeneralComponents/GeneralModal.vue'
import GeneralButton from '@/components/GeneralComponents/GeneralButton.vue'
import useFinancialItem from "@/composables/financial_management/financial_item/useFinancialItem";

const financialItem = useFinancialItem('material')

export default {
  components: {GeneralTable, GeneralModal, GeneralButton},

  mounted() {
    this.fetchData()
  },

  data() {
    return {
      ...financialItem.data(),
    }
  },

  methods: {
    ...financialItem.methods,
  }
}
</script>

<template>
  <div class="p-3">
    <div class="row justify-content-between align-items-end">
      <div class="col-md-4 text-right">
        <label class="form-label fw-bold">عنوان مواد</label>
        <input
            type="text"
            class="form-control"
            v-model="newItem.title"
        />
      </div>

      <div class="col-md-4 text-right">
        <label class="form-label fw-bold">واحد سنجش</label>
        <input
            type="text"
            class="form-control"
            v-model="newItem.unit"
        />
      </div>

      <div class="col-md-2">
        <GeneralButton @clicked="addItem"/>
      </div>
    </div>

    <hr class="my-3">

    <!-- Items Table -->
    <GeneralTable
        :headers="tableHeaders"
        :fields="tableFields"
        :items="items"
        :openEditModalMethod="openEditModal"
        @remove="removeItem"
        scrollable-class="table-scrollable-size-20"
    />

    <!-- Edit Item Modal -->
    <GeneralModal
        v-show="editedItem"
        title="ویرایش"
        modal-id="modalId"
        @save="handleUpdate"
    >
      <template v-if="editedItem">
        <div class="row justify-content-center align-items-end">
          <div class="col-md-6 text-right">
            <label class="form-label fw-bold">عنوان مواد</label>
            <input
                type="text"
                class="form-control"
                v-model="editedItem.title"
            />
          </div>

          <div class="col-md-6 text-right">
            <label class="form-label fw-bold">واحد سنجش</label>
            <input
                type="text"
                class="form-control"
                v-model="editedItem.unit"
            />
          </div>
        </div>
      </template>
    </GeneralModal>
  </div>
</template>
